<template>
  <v-container
    text-xs-center
    class="mt-2 pt-0 px-4"
  >
    <v-card
      v-if="!enterLoading"
      flat
      class="mx-2 animated fadeIn delay-1s"
    >
      <v-layout
        row
        wrap
        class="mt-3 mb-2"
      >
        <!-- <v-flex xs12 v-if="getCustomer.id === '5f3960ccdb0e3500032c99ad' && eventCatalogue">
            <v-toolbar-items class="toolbarItems">
              <v-btn class="mb-4 elevation-1" block outline color='#099AB1' @click="copyLinkToClipboard(eventCatalogue.id)" height="40px">
                <v-icon class="pr-1">content_copy</v-icon>
                <h4 class="ma-2 pl-2">Link catálogo de Páscoa</h4>
              </v-btn>
            </v-toolbar-items>
          </v-flex> -->

        <v-flex
          xs12
          class="catalogue-select text-xs-left"
        >
          Escolha um catálogo para visualizar o conteúdo:
        </v-flex>
        <v-flex
          align-self-left
          xs8
        >
          <v-autocomplete
            v-model="selectedTemplateCatalogue"
            :items="catalogueSelectItems"
            :loading="catalogueLoading"
            append-icon="mdi-chevron-down"
            item-text="name"
            return-object
            class="catalogue-select__select"
            color="#140C22"
            no-data-text="Nenhum catálogo encontrado..."
            @change="resetAndGetProducts"
          />
        </v-flex>
        <v-flex
          xs4
          style="text-align: end;"
          align-self-center
        >
          <v-btn
            id="copyLink"
            depressed
            :loading="copyLoading"
            class="catalogue-select__copy-link ma-0 px-0"
            outline
            color="#140C22"
            @click="copyCatalogueLink"
          >
            <span style="text-transform: none">
              Copiar link
            </span>
          </v-btn>
        </v-flex>
      </v-layout>

      <v-divider style="border: 1px solid #DDDDDD" />

      <v-layout
        row
        wrap
        class="mt-4"
        align-center
      >
        <v-flex
          xs6
          class="catalogue-select__catalogue-name"
        >
          {{ selectedTemplateCatalogue.name }}
        </v-flex>
        <v-flex
          v-if="canPersonalize"
          xs6
          style="text-align: end;"
        >
          <v-btn
            id="personalize"
            depressed
            class="catalogue-select__personalize secondary-btn"
            color="#140C22"
            @click="goToPersonalize(getCustomer.salesAssistant)"
          >
            <span style="text-transform: capitalize">
              Personalizar catálogo
            </span>
          </v-btn>
          <v-btn
            v-if="selectedTemplateCatalogue.catalogueId"
            id="unfavorite"
            depressed
            outline
            :loading="unfavoriteLoading"
            class="catalogue-select__personalize secondary-btn mt-0"
            color="#140C22"
            @click="unfavoriteDialog = true"
          >
            <v-icon
              class="mr-1"
              small
              color="#140C22"
            >
              mdi-heart-broken
            </v-icon>
            <span style="text-transform: capitalize">
              Desfavoritar
            </span>
          </v-btn>
        </v-flex>
      </v-layout>
      <v-layout
        row
        wrap
        class="search"
        align-center
      >
        <v-flex
          align-self-left
          xs9
        >
          <v-combobox
            ref="combobox"
            v-model="catalogueFilters"
            append-icon="mdi-chevron-down"
            :items="allFilters"
            :menu-props="{
              closeOnContentClick: true
            }"
            dense
            small-chips
            clearable
            deletable-chips
            hide-selected
            :label="getCustomer.salesAssistant ? 'Buscar produto ou setor' : 'Buscar produto, setor ou categoria'"
            multiple
            no-data-text="Nenhum resultado encontrado..."
            :disabled="!loadedProducts"
            @change="reset"
          />
        </v-flex>
        <v-flex
          xs3
          style="text-align: end;"
        >
          <v-btn
            depressed
            outline
            color="#140C22"
            class="barcode ma-0 px-0"
            :disabled="!loadedProducts"
            @click="openCamera"
          >
            <v-icon
              small
              color="primary"
            >
              $vuetify.icons.barCodeScanner
            </v-icon>
          </v-btn>
        </v-flex>
      </v-layout>

      <v-layout
        row
        wrap
        class="order-by__txt"
        align-center
      >
        <v-flex
          xs4
        >
          <v-select
            ref="sectorSelect"
            v-model="catalogueSectorFilters"
            :items="allSectors"
            append-icon="$vuetify.icons.arrowDownIcon"
            :disabled="!loadedProducts"
            class="sector-filter"
            filled
            :menu-props="{ bottom: true, offsetY: true, closeOnContentClick: true}"
            dense
            @click.native.prevent.stop.capture="$event.stopPropagation()"
            @mouseup="handleClick('sectorSelect')"
          >
            <template #label>
              <span
                class="sector-filter__slot"
              >
                Setores
              </span>
            </template>
            <template #selection="{ item }">
              <span class="sector-filter__select">
                {{ item }}
              </span>
            </template>
            <template #item="{ item }">
              <v-list-tile-content class="sector-filter__tile">
                {{ item }}
              </v-list-tile-content>
            </template>
          </v-select>
        </v-flex>
        <v-flex
          xs5
          style="text-align: end;"
        >
          <span class="order-by__arrows">
            ↑↓
          </span>
          <span class="mr-3">
            Ordenar por:
          </span>
        </v-flex>
        <v-flex xs3>
          <v-select
            ref="sortSelect"
            v-model="catalogueSortAsc"
            :items="sort"
            item-text="label"
            append-icon=""
            filled
            :menu-props="{ bottom: true, offsetY: true }"
            dense
            @click.native.prevent.stop.capture="$event.stopPropagation()"
            @mouseup="handleClick('sortSelect')"
          >
            <template #selection="{ item }">
              <span class="order-by__select">
                {{ item.label }}
              </span>
            </template>
            <template #item="{ item }">
              <v-list-tile-content class="order-by__select">
                {{ item.label }}
              </v-list-tile-content>
            </template>
          </v-select>
        </v-flex>
      </v-layout>

      <v-layout
        row
        wrap
        justify-space-around
        class="mb-5 pb-2"
      >
        <v-flex
          v-for="(product, index) in filteredProducts"
          :key="product.sku"
          xs6
          md3
        >
          <vue-intersect @enter="setProductVisible(index)">
            <ProductCard
              :product="product"
              :store="store"
            />
          </vue-intersect>
        </v-flex>
      </v-layout>
      <div style="margin-bottom: 150px">
        <infinite-loading
          ref="infiniteLoading"
          spinner="spiral"
          force-use-infinite-wrapper
          @infinite="infiniteHandler"
        >
          <div slot="no-results">
            Sem mais resultados
          </div>
          <div slot="no-more">
            Sem mais resultados
          </div>
        </infinite-loading>
      </div>
    </v-card>
    <v-dialog
      v-if="barCodeDialog"
      v-model="barCodeDialog"
      persistent
      max-width="330"
    >
      <BarCodeDialog
        :products="products"
        @close-camera="closeCamera"
      />
    </v-dialog>

    <v-dialog
      v-model="unfavoriteDialog"
      max-width="317"
    >
      <ActionsDialog
        :dialog-text="`${sellerFirstName}, você tem certeza que deseja remover o catálogo “${selectedTemplateCatalogue.name}” dos favoritos?`"
        first-text="Sim, desfavoritar catálogo"
        second-text="Quero manter nos favoritos"
        :first-action="unfavoriteCatalogue"
        :second-action="() => { unfavoriteDialog = false }"
        :close="() => { unfavoriteDialog = false }"
      />
    </v-dialog>
    <v-dialog
      v-model="identifyPersonDialog"
      max-width="379"
    >
      <IdentifyPersonDialog
        :go-to-personalize="goToPersonalize"
        :close="() => { identifyPersonDialog = false }"
      />
    </v-dialog>
    <v-progress-circular
      v-if="enterLoading"
      class="progress-circular"
      size="50"
      width="4"
      color="#140C22"
      indeterminate
    />
  </v-container>
</template>

<script>
/* eslint-disable camelcase */
import { everything } from '@sejazipper/layer-api-client';
// eslint-disable-next-line import/no-unresolved
import Promise from 'bluebird';
import { mapGetters } from 'vuex';
import VueIntersect from 'vue-intersect';
import Quagga from 'quagga';
import ProductCard from '@/components/Product/ProductCard';
// eslint-disable-next-line import/no-unresolved
import ActionsDialog from '@/components/ActionsDialog';
// eslint-disable-next-line import/no-unresolved, import/extensions
import { APIService } from '@/resources/campanha.js';
// eslint-disable-next-line import/no-unresolved, import/extensions
import { EventBus } from '@/event-bus.js';
import { useZipperApi } from '../composables/useZipperApi';
import BarCodeDialog from '../components/Product/BarCodeDialog.vue';
import { removeDuplicatesByAttribute } from '../utils/utils';

const shortid = require('shortid');
// eslint-disable-next-line import/no-extraneous-dependencies
const _ = require('lodash');
const Wade = require('wade');

const api = new APIService();
const { client } = useZipperApi();

export default {
  components: {
    ProductCard,
    ActionsDialog,
    VueIntersect,
    BarCodeDialog,
  },

  data: () => ({
    page: 0,
    size: 25,
    store: {},
    enterLoading: true,
    awaitingSearch: false,
    allFilters: [],
    allSectors: [],
    products: [],
    productsToReplace: [],
    filters: null,
    search: null,
    totalProducts: null,
    selectingAllProducts: false,
    addingProducts: false,
    eventCatalogue: null,
    catalogueLink: null,
    barCodeDialog: false,
    sort: [
      {
        label: 'Maior Preço',
        value: false,
      },
      {
        label: 'Menor Preço',
        value: true,
      },
    ],
    searchHeaders: {
      categories: { header: 'Categoria:' },
      sizes: { header: 'Tamanho:' },
      colors: { header: 'Cor:' },
      sectors: { header: 'Setor:' },
    },
    templateCatalogues: [],
    favoriteCatalogues: [],
    catalogueSelectItems: [],
    selectedTemplateCatalogue: {},
    copyLoading: false,
    loadedProducts: false,
    unfavoriteLoading: false,
    catalogueLoading: false,
    unfavoriteDialog: false,
    identifyPersonDialog: false,
    searchProducts: [],
    dbInstance: null,
  }),

  computed: {
    ...mapGetters(['getStore', 'getCustomer', 'getCatalogueSortAsc', 'getCatalogue', 'getCatalogueSectorFilters', 'getProfile']),

    catalogueSortAsc: {
      get() {
        return this.$store.state.catalogueSortAsc;
      },
      set(value) {
        this.$store.commit('SET_CATALOGUE_SORT_ASC', value);
      },
    },

    finalProducts() {
      let { products } = this;

      if (this.catalogueFilters.length) {
        if (!this.searchProducts.length) this.handleSearch();
        products = this.searchProducts;
      }

      if (products.length) {
        this.resetInfiniteLoading();
      }

      return products;
    },

    slicedProducts() {
      const sortedProducts = this.sortProductsBySkuPrice(this.finalProducts, this.catalogueSortAsc);

      return sortedProducts.slice(0, this.size * (this.page + 1));
    },

    filteredProducts() {
      const productsInStock = this.slicedProducts.filter((p) => (Math.max(...p.skus.map((sku) => sku.sku_prices[0].price))) > 0).map((product) => ({
        ...product,
        visible: false,
      }));
      const sortedProducts = _.orderBy(productsInStock, 'mainImage');

      return this.selectedTemplateCatalogue.catalogueId
        ? this.filterProductsByidERP(sortedProducts)
        : this.filterProductsSkusByTemplateCatalogue(sortedProducts);
    },

    catalogueFilters: {
      get() {
        return this.$store.state.catalogueFilters;
      },
      async set(value) {
        this.$store.commit('SET_CATALOGUE_FILTERS', value);
      },
    },

    catalogueSectorFilters: {
      get() {
        return this.getCatalogueSectorFilters;
      },

      set(sectorFilter) {
        this.$store.dispatch('setCatalogueSectorFilters', sectorFilter);
      },
    },

    catalogueId() {
      if (this.selectedTemplateCatalogue.catalogueId) {
        return this.selectedTemplateCatalogue.catalogueId;
      }
      return this.selectedTemplateCatalogue._id;
    },

    canPersonalize() {
      return (this.selectedTemplateCatalogue.defaultTemplateCatalogue && !this.getStore.defaultTemplateCatalogueId)
        || this.selectedTemplateCatalogue._id === this.getStore.defaultTemplateCatalogueId
        || this.selectedTemplateCatalogue.catalogueId;
    },

    catalogueIcon() {
      return this.selectedTemplateCatalogue.catalogueId
        ? '$vuetify.icons.heartOutlineIcon'
        : '$vuetify.icons.storeIcon';
    },

    sellerFirstName() {
      const names = this.getProfile.name.trim().split(' ');

      return names[0];
    },

    searchSectors() {
      const sectors = _.uniq(this.products.map((product) => product.setor)).filter((product) => product);
      const custom = _.uniq(this.products.map((product) => product.customSector)).filter((product) => product);
      const combined = sectors.concat(custom);

      return combined;
    },
  },

  watch: {
    async catalogueFilters() {
      if (this.awaitingSearch) return;
      await this.handleSearch();
    },
    async getStore(store) {
      if (store) {
        this.page = 0;
        this.products = [];
        await this.getAllCorridorProducts();
        this.store = await client.chain.query.findStoreByMongoId({
          mongoId: store.id,
        }).get({ ...everything });
      }
    },
  },

  async mounted() {
    this.$store.dispatch('clearCheckout');
    this.$store.dispatch('setPersonAsIdentified', false);

    this.store = await client.chain.query.findStoreByMongoId({
      mongoId: this.getStore.id,
    }).get({ ...everything });

    setTimeout(() => {
      this.enterLoading = false;
    }, 500);

    window.addEventListener('click', this.handleSectorClickOutside);
    window.addEventListener('click', this.handleSortClickOutside);
  },

  destroyed() {
    window.removeEventListener('click', this.handleSectorClickOutside);
    window.removeEventListener('click', this.handleSortClickOutside);
  },

  methods: {
    getAllProducts() {
      return new Promise((resolve, reject) => {
        const request = window.indexedDB.open('product_catalog', 1);

        request.onupgradeneeded = (event) => {
          this.dbInstance = event.target.result;
          if (!this.dbInstance.objectStoreNames.contains('product_catalog')) {
            this.dbInstance.createObjectStore('product_catalog', { autoIncrement: true });
          }
        };

        request.onsuccess = (event) => {
          this.dbInstance = event.target.result;
          const transaction = this.dbInstance.transaction(['product_catalog'], 'readonly');
          const objectStore = transaction.objectStore('product_catalog');

          const productsRequest = objectStore.getAll();

          productsRequest.onsuccess = () => {
            const products = productsRequest.result;
            resolve(products);
          };

          productsRequest.onerror = () => {
            reject(new Error('Erro ao carregar os produtos.'));
          };
        };

        request.onerror = (event) => {
          reject(new Error('Erro no IndexedDB', event));
        };
      });
    },

    saveProducts(productData) {
      return new Promise((resolve, reject) => {
        const request = window.indexedDB.open('product_catalog', 1);

        request.onupgradeneeded = (event) => {
          this.dbInstance = event.target.result;
          if (!this.dbInstance.objectStoreNames.contains('product_catalog')) {
            this.dbInstance.createObjectStore('product_catalog', { autoIncrement: true });
          }
        };

        request.onsuccess = async (event) => {
          this.dbInstance = event.target.result;

          const transaction = this.dbInstance.transaction(['product_catalog'], 'readwrite');
          const objectStore = transaction.objectStore('product_catalog');

          const clearRequest = objectStore.clear();

          clearRequest.onsuccess = async () => {
            const data = { data: JSON.stringify(productData), id: 1 };

            const saveRequest = objectStore.add(data);

            saveRequest.onsuccess = () => {
              resolve('Produtos salvos com sucesso');
            };

            saveRequest.onerror = (error) => {
              reject(new Error('Erro ao salvar os produtos', error));
            };
          };

          clearRequest.onerror = (error) => {
            console.error('Erro ao limpar o object store', error);
            reject(new Error('Erro ao limpar o object store'));
          };
        };

        request.onerror = (event) => {
          reject(new Error('Erro no IndexedDB', event));
        };
      });
    },

    handleClick(ref) {
      this.$refs[ref].isMenuActive = !this.$refs[ref].isMenuActive;
    },
    handleSectorClickOutside() {
      this.$refs.sectorSelect.isMenuActive = false;
    },
    handleSortClickOutside() {
      this.$refs.sortSelect.isMenuActive = false;
    },
    reset() {
      this.$refs.combobox.lazySearch = '';
      this.$refs.combobox.isMenuActive = false;
    },

    async infiniteHandler($state) {
      if (this.awaitingSearch) return;
      if (!this.selectedTemplateCatalogue._id) await this.getCatalogueSelectItems();
      if (!this.products.length && !this.loadedProducts) {
        await this.getAllCorridorProducts();
        this.getFilters();
        this.allSectors = ['Todos os produtos', ...this.filters.sectors, 'Outlet', 'Pré-venda'];
        $state.loaded();
        return;
      }

      if (this.slicedProducts.length < this.finalProducts.length) {
        this.page += 1;
        $state.loaded();
      } else {
        $state.complete();
      }
    },

    getFilters() {
      const skus = _.flatten(this.products.map((product) => product.skus));
      const filters = {
        sectors: this.searchSectors,
        categories: !this.getCustomer.salesAssistant
          ? _.uniq(this.products.map((product) => product.categoria)).filter((product) => product) : [],
        sizes: _.uniq(skus.map((sku) => sku.size)).filter((product) => product),
        colors: _.uniq(skus.map((sku) => sku.color)).filter((product) => product),
      };

      Object.entries(filters).forEach((filter) => {
        if (filter[1].length) {
          this.allFilters = this.allFilters
            .concat(this.searchHeaders[filter[0]])
            .concat(filter[1]);
        }
      });

      this.filters = filters;
    },

    async getCorridorProducts(corridor, isCached = false) {
      if (!this.getCustomer) return;

      try {
        let products = await client.chain.query.findOMSProductsByCorridor({
          customerId: this.getCustomer.id,
          corridor: {
            ...corridor,
            hasImage: false,
            hasStock: this.getCustomer.name !== 'Angeloni',
          },
          storesIds: [this.getStore.id],
        }).get({
          id: true,
          descricaoCurta: true,
          categoria: true,
          grupoProduto: true,
          setor: true,
          cor: true,
          reference: true,
          mainImage: true,
          imagens: true,
          skus: {
            ...everything,
            sku_id_erp: true,
            sku_add_ons: true,
            sku_images: true,
            sku_datasheets: true,
            sku_prices: true,
            sku_stocks: true,
            ...everything,
          },
        });

        if (!products.length) return;

        // Se o produto não for regular, valida se ele possui estoque na loja selecionada,
        // caso contrário valida se ele possui estoque em pelo menos um loja

        products = products.filter((product) => product.skus.find((sku) => sku.sku_stocks.find((stock) => stock.stock > 0)));

        if (isCached) {
          this.productsToReplace = this.productsToReplace.concat(products);
        } else {
          this.products = this.products.concat(products);
        }
        this.$store.dispatch('setProducts', isCached ? this.productsToReplace : this.products);
      } catch (e) {
        console.log(e);
      }
    },

    async getAllCorridorProducts() {
      this.loadedProducts = false;

      if (!this.getCustomer) return false;
      let { corridors } = this.selectedTemplateCatalogue;

      if (!corridors) {
        const templateByCatalogue = this.templateCatalogues.find((template) => (
          template._id === this.selectedTemplateCatalogue._id
        ));

        corridors = templateByCatalogue.corridors || [];
      }

      this.store = await client.chain.query.findStoreByMongoId({
        mongoId: this.getStore.id,
      }).get({ ...everything });

      const allProducts = await this.getAllProducts();

      const cachedProducts = allProducts && allProducts.length && allProducts[0].data !== '[]' ? JSON.parse(allProducts[0].data) : null;

      const cachedTimestamp = localStorage.getItem('products_timestamp');
      const catalogueId = localStorage.getItem('catalogueId');
      const catalogue_id = localStorage.getItem('catalogue_id');
      const storeIdErp = localStorage.getItem('storeIdErp');
      const currentTimestamp = new Date().getTime();

      /**
       * Se:
       * - Existir produtos no cache do navegador
       * - A diferença entre a última atualização e o horário atual for MENOR que 3 minutos
       * - O id do catálogo for igual ao id salvo no navegador
       * - A loja selecionada ser igual a loja salva no navegador
       * Então utiliza os produtos do cache diretamente
       */
      if (
        cachedProducts && cachedTimestamp && (currentTimestamp - cachedTimestamp) < (3 * 60 * 1000)
        && catalogueId === String(this.selectedTemplateCatalogue.catalogueId) && catalogue_id === this.selectedTemplateCatalogue._id && storeIdErp === this.store.id_erp
      ) {
        this.products = cachedProducts;
        this.$store.dispatch('setProducts', this.products);
        await this.saveProducts(this.products);
      } else if ((cachedProducts && cachedTimestamp && (currentTimestamp - cachedTimestamp) > (3 * 60 * 1000))
        && catalogueId === String(this.selectedTemplateCatalogue.catalogueId) && catalogue_id === this.selectedTemplateCatalogue._id && storeIdErp === this.store.id_erp
      ) {
        /**
         * Se:
         * - Existir produtos no cache do navegador
         * - A diferença entre a última atualização e o horário atual for MAIOR que 3 minutos
         * - O id do catálogo for igual ao id salvo no navegador
         * - A loja selecionada ser igual a loja salva no navegador
         * Então utiliza os produtos do cache, porém atualiza eles em background para garantir que os preços/estoques estejam atualizados
        */

        this.products = cachedProducts;
        this.$store.dispatch('setProducts', this.products);
        await this.saveProducts(this.products);

        this.loadedProducts = true;
        await Promise.map(corridors, async (corridor) => this.getCorridorProducts(corridor, true));

        localStorage.setItem('products_timestamp', currentTimestamp.toString());

        this.products = this.productsToReplace;
        this.$store.dispatch('setProducts', this.products);
        await this.saveProducts(this.products);

        // eslint-disable-next-line no-restricted-syntax
        for (const product of this.products) {
          if (product.skus.some((sku) => sku.product_type_id < 4)) {
            this.$set(product, 'customSector', 'Outlet');
          }
        }
      } else {
        await Promise.map(corridors, async (corridor) => this.getCorridorProducts(corridor));

        await this.saveProducts(this.products);
        localStorage.setItem('products_timestamp', currentTimestamp.toString());
        localStorage.setItem('catalogueId', this.selectedTemplateCatalogue.catalogueId);
        localStorage.setItem('catalogue_id', this.selectedTemplateCatalogue._id);
        localStorage.setItem('storeIdErp', this.store.id_erp);

        // eslint-disable-next-line no-restricted-syntax
        for (const product of this.products) {
          if (product.skus.some((sku) => sku.product_type_id < 4)) {
            this.$set(product, 'customSector', 'Outlet');
          }
        }
      }

      this.loadedProducts = true;
      console.log('Terminou o ELSE');
      return true;
    },

    copyLinkToClipboard(id) {
      const catalogueLink = `https://shopper.kopenhagen.com.br/${id}`;
      const elem = document.createElement('textarea');
      elem.value = catalogueLink;
      document.body.appendChild(elem);
      elem.select();
      document.execCommand('copy');
      document.body.removeChild(elem);

      this.emitSnackbar('#099AB1', 'Link copiado com sucesso');
    },

    emitSnackbar(text) {
      const snackBar = {};
      snackBar.value = true;
      snackBar.text = text;
      snackBar.color = '#140C22';
      snackBar.button = false;
      snackBar.icon = '$vuetify.icons.checkIcon';
      snackBar.class = {
        height: '120px',
        'font-size': '16px',
        'font-weight': '600',
        'justify-content': 'center',
      };
      EventBus.$emit('activeSnackBar', snackBar);
    },

    resetInfiniteLoading() {
      this.$refs.infiniteLoading.stateChanger.reset();
    },

    completeInfiniteLoading() {
      this.$refs.infiniteLoading.stateChanger.loaded();
    },

    async resetAndGetProducts() {
      this.$store.dispatch('setCatalogueId', this.catalogueId);
      this.getCatalogueLink();
      this.awaitingSearch = true;
      this.page = 0;
      this.products = [];
      this.resetInfiniteLoading();
      await this.getAllCorridorProducts();
      this.awaitingSearch = false;
      this.completeInfiniteLoading();
    },

    async getFavoriteCatalogues() {
      const res = await client.chain.query
        .findAllFavoriteCataloguesBySellerIdAndStoreId({
          customerId: this.getCustomer.id,
          sellerId: this.$auth.user.sub,
          storeId: this.getStore.id,
        })
        .get({ ...everything });
      this.favoriteCatalogues = res.map((catalogue) => ({
        _id: catalogue.templateCatalogueId,
        name: catalogue.favoriteName,
        catalogueId: catalogue._id,
        productIds: catalogue.productIds,
      }));
      this.$store.dispatch(
        'setMaxFavoriteCatalogues',
        this.favoriteCatalogues.length === 5,
      );
    },

    async getTemplateCatalogues() {
      const res = await client.chain.query
        .findAllTemplateCatalogue({ customerId: this.getCustomer.id })
        .get({
          ...everything,
          corridors: {
            ...everything,
            priceRange: { ...everything, __typename: false },
            saleRange: { ...everything, __typename: false },
            __typename: false,
          },
        });
      this.templateCatalogues = res.filter((template) => !template.disabled);
    },

    async getCatalogueSelectItems() {
      this.catalogueLoading = true;
      this.catalogueSelectItems = [];

      await Promise.all([
        this.getFavoriteCatalogues(),
        this.getTemplateCatalogues(),
      ]);

      if (this.favoriteCatalogues.length) {
        this.catalogueSelectItems = this.catalogueSelectItems.concat(
          [{ header: `Catálogos Favoritos (${this.favoriteCatalogues.length}/5):` }],
          this.favoriteCatalogues,
        );
      }
      this.catalogueSelectItems = this.catalogueSelectItems.concat(
        [{ header: 'Catálogos:' }],
        this.templateCatalogues,
      );
      this.selectedTemplateCatalogue = this.getDefaultTemplateCatalogue();
      this.getCatalogueLink();

      this.catalogueLoading = false;
    },

    getDefaultTemplateCatalogue() {
      let templateCatalogue = this.templateCatalogues.find((template) => (
        (template._id === this.getStore.defaultTemplateCatalogueId)
      ));
      if (!templateCatalogue) {
        templateCatalogue = this.templateCatalogues.find((template) => template.defaultTemplateCatalogue) || {};
      }
      this.$store.dispatch('setCatalogueId', templateCatalogue._id);
      return templateCatalogue;
    },

    discountFilter(product, corridor) {
      if (
        !corridor.saleRange
        || (!corridor.saleRange.start && !corridor.saleRange.end)
      ) return true;
      const { start, end } = corridor.saleRange;
      const discount = Math.abs((product.price / product.oldPrice) - 1) * 100 || 0.0;
      return discount >= start && discount <= end;
    },

    priceFilter(product, corridor) {
      if (
        !corridor.priceRange
        || (!corridor.priceRange.start && !corridor.priceRange.end)
      ) return true;
      const { start, end } = corridor.priceRange;
      return product.price >= start && product.price <= end;
    },

    sizesFilter(product, corridor) {
      if (
        !corridor.sizes
        || !corridor.sizes.length
      ) return true;
      return corridor.sizes.includes(product.size);
    },

    sectorFilter(product) {
      if (this.catalogueSectorFilters === 'Todos os produtos') return true;
      if (this.catalogueSectorFilters === 'Outlet') return product.skus.find((sku) => sku.product_type_id < 4);
      if (this.catalogueSectorFilters === 'Pré-venda') return product.skus.find((sku) => sku.product_type_id === 12);
      return product.setor === this.catalogueSectorFilters;
    },

    filterProductsSkusByTemplateCatalogue(products) {
      return products.filter((product) => (
        product.skus.some((sku) => (
          this.selectedTemplateCatalogue.corridors.some((corridor) => (
            this.priceFilter(sku, corridor)
              && this.discountFilter(sku, corridor)
              && this.sizesFilter(sku, corridor)
              && this.sectorFilter(product)
          ))
        ))
      ));
    },

    filterProductsByidERP(products) {
      return products.filter((product) => (
        this.selectedTemplateCatalogue.productIds.includes(product.id)
      ));
    },

    copyCatalogueLink() {
      window.Clipboard.copy(this.catalogueLink);
      this.emitSnackbar('Link copiado com sucesso');
    },

    generateCatalogueURL(catalogueId) {
      if (this.getCustomer.nickname) {
        return `https://${this.getCustomer.nickname.toLowerCase()}.whts.shop/${catalogueId}`;
      }
      return `https://shop.sejazipper.com/${catalogueId}`;
    },

    async createCatalogue() {
      const catalogo = {
        id: shortid.generate(),
        storeId: this.getStore.id,
        customerId: this.getCustomer.id,
        sellerId: this.$auth.user.sub,
        templateCatalogueId: this.selectedTemplateCatalogue._id,
      };
      const catalogue = await api.createCatalogue(catalogo);
      return this.generateCatalogueURL(catalogue.id);
    },

    async getCatalogueLink() {
      this.copyLoading = true;
      if (this.selectedTemplateCatalogue.catalogueId) {
        this.catalogueLink = this.generateCatalogueURL(this.selectedTemplateCatalogue.catalogueId);
      } else {
        this.catalogueLink = await client.chain.query
          .getCatalogueLinkByTemplateCatalogueIdAndSellerId({
            customerId: this.getCustomer.id,
            storeId: this.getStore.id,
            sellerId: this.$auth.user.sub,
            templateCatalogueId: this.selectedTemplateCatalogue._id,
          })
          .get(true);
      }
      if (!this.catalogueLink) this.catalogueLink = await this.createCatalogue();
      this.copyLoading = false;
    },

    async unfavoriteCatalogue() {
      this.unfavoriteDialog = false;
      this.unfavoriteLoading = true;
      await client.chain.mutation
        .unfavoriteCatalogueByIdAndSellerId({
          customerId: this.getCustomer.id,
          catalogueId: this.selectedTemplateCatalogue.catalogueId,
          sellerId: this.$auth.user.sub,
        })
        .get(true);
      await this.getCatalogueSelectItems();
      this.emitSnackbar('Catálogo removido dos favoritos com sucesso');
      this.unfavoriteLoading = false;
      await this.resetAndGetProducts();
    },

    goToPersonalize(identifyPerson) {
      if (identifyPerson) {
        this.identifyPersonDialog = true;
        return;
      }

      this.$store.dispatch('clearCheckout');
      this.$router.push('/personalizar');
    },

    getSearchMap(products) {
      return products.map((product) => {
        const skus = product.skus.find((sku) => sku.ean);
        if (this.getCustomer.salesAssistant) {
          return `${product.descricaoCurta} ${product.cor} ${product.setor} ${skus.ean} ${skus.sku_id_erp} ${product.reference}`;
        }
        return `${product.descricaoCurta} ${product.cor} ${product.setor} ${product.categoria} ${skus.ean} ${skus.sku_id_erp} ${product.reference}`;
      });
    },

    handleSearch() {
      if (!this.loadedProducts) return;

      let filters = this.catalogueFilters;
      let { products } = this;
      const { sizes, sectors } = this.filters || {};
      const size = filters.find((filter) => sizes && sizes.includes(filter));
      const sector = filters.find((filter) => sectors && sectors.includes(filter));

      if (size) {
        const filteredProducts = products.filter((p) => (
          p.skus.some((sku) => (
            sku.size === size
            && sku.currentStock > 0
            && sku.idLoja === this.getStore.id
          ))
        ));
        filters = filters.filter((input) => !sizes.includes(input));
        products = filteredProducts;
      }

      if (sector) {
        const filteredProducts = products.filter((p) => p.setor === sector || p.customSector === sector);
        filters = filters.filter((input) => !sector.includes(input));
        products = filteredProducts;
      }

      let searchResults = products;
      filters = filters.join(' ').split(/\s+/).filter((f) => f);

      filters.forEach((filter) => {
        const search = Wade(this.getSearchMap(searchResults));
        searchResults = search(filter).map((sr) => searchResults[sr.index]);
      });

      this.searchProducts = removeDuplicatesByAttribute(searchResults, 'id');
      this.page = 0;
    },

    sortProductsBySkuPrice(products, isOrderAsc) {
      products.forEach((product) => {
        product.skus.forEach((sku) => {
          sku.sku_prices.sort((a, b) => a.price - b.price);
        });
      });

      if (isOrderAsc) {
        products.sort((a, b) => a.skus[0].sku_prices.find((price) => price.store_id === this.store.id).price - b.skus[0].sku_prices.find((price) => price.store_id === this.store.id).price);
      } else {
        products.sort((a, b) => b.skus[0].sku_prices.find((price) => price.store_id === this.store.id).price - a.skus[0].sku_prices.find((price) => price.store_id === this.store.id).price);
      }

      return products;
    },

    setProductVisible(index) {
      this.filteredProducts[index].visible = true;
    },

    openCamera() {
      this.barCodeDialog = true;
    },

    closeCamera() {
      this.barCodeDialog = false;
      Quagga.stop();
    },
  },

};
</script>

<style scoped lang="scss">

.toolbar {
  position: sticky;
  top: 0;
  z-index: 2;
  padding-top: 60px;
}

.toolbarItems {
  width: 100%;
  height: 34px;
}

.order-by {
  font-family: 'Nunito sans';
  font-style: normal;
  &__txt {
    font-weight: 300;
    font-size: 10px !important;
    white-space: nowrap;
  }
  &__arrows {
    font-weight: 1000;
    font-size: 16px;
  }
  &__select {
    font-family: 'Nunito sans';
    font-weight: 400;
    font-size: 10px;
    line-height: 28px;
  }
}

.sector-filter {
  font-family: 'Nunito sans';
  font-style: normal;
  line-height: 14px;
  &__txt {
    font-weight: 300;
    font-size: 10px !important;
  }
  &__select {
    font-family: 'Nunito sans';
    font-weight: 400;
    font-size: 9px;
    line-height: 10px;
    white-space: nowrap;
  }
  &__tile {
    font-family: 'Nunito sans';
    font-style: normal;
    font-size: 10px;
  }
  &__title {
    padding-left: 0px;
    line-height: 14px;
    font-size: 10px;
    font-weight: 400;
  }
  &__slot {
    font-family: 'Nunito sans';
    font-style: normal;
    font-size: 14px ;
    line-height: 0px;
    word-wrap: break-word;
  }
}

::v-deep .v-list__tile {
  border: 1px solid #F1F1F1;
  &__title {
    padding-left: 30px;
    font-size: 10px;
    font-family: 'Neue-Metana';
    font-style: normal;
    font-weight: 400;
    line-height: 21px;
    text-transform: lowercase;
  }
  &__title::first-letter {
    text-transform: uppercase;
  }
}

.catalogue-select {
  font-family: 'Nunito Sans';
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0em;
  &__copy-link {
    color: #140C22;
    width: 100px;
    height: 32px;
    font-size: 12px;
    font-weight: 500;
    text-align: center;
    border-radius: 6px;
  }
  &__personalize {
    width: 150px;
    height: 32px;
    font-size: 12px;
    font-weight: 600;
    text-align: center;
    border-radius: 6px;
    color: white;
    margin-right: 0;
  }
  &__select {
    width: 90%;
  }
  &__catalogue-name {
    font-family: 'Nunito Sans';
    font-style: normal;
    font-weight: 600;
    font-size: 2.4vh;
    text-align: start;
  }
  &__combobox {
    width: 37.5vh;
  }
}

.barcode {
    color: #140C22;
    width: 52px;
    height: 30px;
    font-weight: 500;
    text-align: center;
    border-radius: 6px;
    padding: 7px;
  }

@media all and (min-width: 1200px)  {
  .barcode {
      display: none;
  }

  .search {
    width: 133.5%;
  }
}

.progress-circular {
  height: 50vh !important;
}

::v-deep .v-subheader {
  font-family: 'Neue-Metana';
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  color: #000;
  background-color: #F8F4F0;
  border-radius: 5px;
  height: 45.71px;
}

::v-deep .v-list {
  padding: 0;
}

::v-deep .v-input__control {
  width: 241px;
}

::v-deep .v-select__slot {
  font-family: 'Nunito Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 102%;
}

::v-deep .sector-filter .v-select__selections input {
  display: contents
}

::v-deep .v-btn {
  min-width: 0px;
}

@media all and (max-width: 860px)  {
  ::v-deep .v-chip__content {
  max-width: 170px;
  white-space: nowrap;
  }
}

::v-deep .v-chip__content {
  height: auto;
}

::v-deep .v-chip--removable .v-chip__content {
  white-space: normal;
}

::v-deep .v-chip--small {
  height: auto !important;
}
</style>
